export default class BookingTeams {
    id: number
    bookingId: number
    teamName: string
    teamDescription: string
    createDate: Date
    active: boolean
    [key: string]: any
}